import { PatientsListColumnName } from '@/shared/config';

import { getColumnFilterParams } from './getColumnFilterParams';

// A hidden column takes its filter dropdown with it, so a filter coming from
// the URL would keep narrowing the list with nothing to show or clear it.
export const omitHiddenColumnFilters = (
  searchParams: URLSearchParams,
  hiddenColumns: PatientsListColumnName[],
): URLSearchParams => {
  const visibleParams = new URLSearchParams(searchParams);

  hiddenColumns
    .flatMap(getColumnFilterParams)
    .forEach((param) => visibleParams.delete(param));

  return visibleParams;
};
